import { ReactNode, VFC } from 'react';

import styles from './Notice.module.scss';

type Props = {
  iconColor?: 'orange' | 'gray';
  children: ReactNode;
};

const Notice: VFC<Props> = ({ iconColor = 'orange', children }: Props) => {
  const iconColorCode = {
    orange: '#F3592F',
    gray: '#7A7A7A',
  }[iconColor];

  return (
    <div className={styles.notice}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 0H2C0.9 0 0.00999999 0.9 0.00999999 2L0 20L4 16H18C19.1 16 20 15.1 20 14V2C20 0.9 19.1 0 18 0ZM11 9H9V3H11V9ZM11 13H9V11H11V13Z"
          fill={iconColorCode}
        />
      </svg>

      <div>{children}</div>
    </div>
  );
};

export default Notice;
